import { API_AUTH } from "./common";

const thayDoiLaiSuatApi = {
  lichSuThayDoi: ({ choVayId }) =>
    API_AUTH.get(
      `quan-ly-cho-vay/lich-su-thay-doi-lai-suat?chovayId=${choVayId}`,
      {}
    ),
  xoaThayDoiLaiSuat: ({ id }) =>
    API_AUTH.post(`quan-ly-cho-vay/xoa-thay-doi-lai-suat?id=${id}`, {}),
};

export default thayDoiLaiSuatApi;
